import type { Account } from "./types";

/**
 * The 401k Roth/Traditional split conventions, in one place. The store keeps
 * each 401k as two calculated halves ("<plan> - Roth" / "<plan> - Traditional",
 * ids carrying "(calculated)"); balance submissions feed one "<plan> - INPUT"
 * total that the importer splits by a fixed per-plan ratio. These names/regexes
 * were previously re-declared in aggregate.ts, display.ts, and gather.ts.
 */

export const RETIRE_SPLIT_RE = /^(.*?) - (Roth|Traditional)$/;

/** True for the calculated 401k halves (split from an INPUT total). */
export function isCalculated401k(a: Account): boolean {
  return a.type === "Retirement" && a.id.includes("calculated") && RETIRE_SPLIT_RE.test(a.name);
}

/** The balance-row identity Cowork submits for a split 401k plan. */
export function input401kName(prefix: string): string {
  return `${prefix} - INPUT`;
}

/** Canonical account key: institution|owner|name, lowercased and dashed. */
export function accountKey(institution: string, owner: string, name: string): string {
  return `${institution}|${owner}|${name}`.toLowerCase().replace(/ /g, "-");
}
